/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import PropTypes from 'prop-types';

// Blocks interaction with the capture flow until the initial offline asset
// prefetch (branding, reference media, global instructions) settles. Without
// this, a customer who navigates ahead — or drops offline — before the
// background prefetch finishes can land on a step whose image/video hasn't
// been cached yet, which renders as a broken media element.
const AssetSyncOverlay = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-0 z-[10000] bg-black/70 backdrop-blur-sm flex flex-col items-center justify-center px-6 text-center"
    >
      <div className="w-12 h-12 border-4 border-white/30 border-t-white rounded-full animate-spin mb-4" />
      <p className="text-white font-bold text-base">Getting things ready…</p>
      <p className="text-white/80 text-sm mt-1 max-w-xs">
        Syncing files and instructions so you can keep capturing if you lose connection.
      </p>
    </div>
  );
};

AssetSyncOverlay.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default AssetSyncOverlay;
